import { useCallback, useEffect, useState } from 'react';

import api from '../services/api';

import { fetchCentralAiStatus } from '../services/centralAiMonitorApi';

import {

  DEFAULT_MONITORING_AI_SETTINGS,

  mergeMonitoringAiSettings,

  type MonitoringAiSettings,

} from '../constants/monitoringAiSettings';



async function loadMonitoringAiFromServer(): Promise<MonitoringAiSettings> {

  const [systemRes, statusRes] = await Promise.all([

    api.get<{ monitoring_ai?: Partial<MonitoringAiSettings> }>(
      '/api/settings/system',
      undefined,
      { useCache: false, silentError: true }
    ),

    fetchCentralAiStatus().catch(() => null),

  ]);

  const merged = mergeMonitoringAiSettings(systemRes?.monitoring_ai);

  if (statusRes) {

    return mergeMonitoringAiSettings({

      ...merged,

      server_ai_enabled: statusRes.server_ai_enabled,

      excluded_pool_ids: statusRes.excluded_pool_ids,

      included_pool_ids: statusRes.included_pool_ids ?? merged.included_pool_ids,

      central_monitor_opt_in: statusRes.central_monitor_opt_in,

    });

  }

  return merged;

}



export function useMonitoringAiSettings(enabled = true) {

  const [settings, setSettings] = useState<MonitoringAiSettings>(DEFAULT_MONITORING_AI_SETTINGS);

  const [loading, setLoading] = useState(enabled);



  const refresh = useCallback(async () => {

    if (!enabled) return;

    setLoading(true);

    try {

      setSettings(await loadMonitoringAiFromServer());

    } catch {

      /* 네트워크/취소 시 기존 값 유지 — 토글 직후 DEFAULT로 되돌아가며 스위치가 안 먹는 것처럼 보이는 문제 방지 */

    } finally {

      setLoading(false);

    }

  }, [enabled]);



  const patchMonitoringAi = useCallback((partial: Partial<MonitoringAiSettings>) => {

    setSettings((prev) => mergeMonitoringAiSettings({ ...prev, ...partial }));

  }, []);



  useEffect(() => {

    refresh();

  }, [refresh]);



  return { settings, loading, refresh, patchMonitoringAi };

}

